class ProductVariants extends HTMLElement {
  constructor() {
    super();
    this.updateURL = false;
    this.productHandle = null;
    this.sectionId = null;
    this.productId = null;
    this.productCard = false;
    this.cartProduct = this.dataset.cartProduct;
    this.itemKey = this.dataset.itemKey;
    this.productTemplate = this.dataset.template;
    this.oldVariantId = this.dataset.variantId;
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.addEventListener("change", (event) => this.handleVariantChange(event));
  }

  async handleVariantChange(e) {
    if (e.target.tagName === "SELECT") {
      const selectElement = e.target;
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      this.productHandle = selectedOption.dataset.productHandle;
      this.sectionId = selectedOption.dataset.sectionId;
      this.productId = selectedOption.dataset.productId;
      this.productCard = !this.cartProduct;
    } else if (e.target.dataset.colorSwatch) {
      this.productHandle = e.target.dataset.productHandle;
      this.sectionId = e.target.dataset.sectionId;
      this.productId = e.target.dataset.productId;
      this.productCard = true;
    } else {
      this.productHandle = e.target.dataset.productHandle;
      this.sectionId = e.target.dataset.sectionId;
      this.productId = e.target.dataset.productId;
      if (window.location.href.includes("/collections")) {
        this.productCard = true;
      } else {
        this.productCard = false;
      }
    }

    // Check if we're on a product page
    this.updateURL = window.location.pathname.includes("/products/");

    if (e.target.tagName === "SELECT") {
      this.currentVariant = this.getProductFromSelect();
    } else if (e.target.type === "radio") {
      this.currentVariant = this.getProductFromRadios(e);
    }
    if (this.currentVariant) {
      if (!this.productCard && this.updateURL) this.updateProductURL();
      await this.fetchProductInfo();
      if (this.productTemplate === "volume-discount-mrp") {
        this.updatesForVolumeDiscount();
      }
      if (
        window.location.href.includes("/products") &&
        this.currentVariant[0].available
      ) {
        let customPincode = document.querySelector("pincode-element");
        if (customPincode) {
          pincodeFunctionality();
          document
            .querySelector("pincode-element #pincodeInput")
            ?.addEventListener("input", () => {
              document
                .querySelector(".pincode-failure")
                .classList.add("hidden");
              if (document.querySelector(".add-to-cart-btn")) {
                document
                  .querySelector(".add-to-cart-btn")
                  .removeAttribute("disabled");
              }
              document.querySelector(".pincode-output").style.display = "none";
              document
                .querySelector(".pincode-button")
                .removeAttribute("disabled");
              document.querySelector(".pincode-button").innerHTML = "Check";
              if (
                document.querySelector("pincode-element #pincodeInput").length <
                6
              ) {
                window.isPincodeFetched = false;
              }
            });
        } else {
          this.handlePincode();
        }
      }

      // USP Icon tooltip 
      if (window.location.href.includes("/products")) {
        document.querySelectorAll(".usp__wrapper").forEach((wrapper) => {
          wrapper.addEventListener("click", (e) => {
            handleTooltip(wrapper);
          });
        });

        document.addEventListener("click", (e) => {
          if (!e.target.closest(".usp__wrapper")) {
            document
              .querySelectorAll(".tooltip")
              .forEach((t) => t.classList.add("tw-hidden"));
          }
        });
      }
    } else {
      this.setUnavailable();
    }
  }

  handlePincode() {
    document
      .querySelector("input[name=drop_pincode]")
      .addEventListener("input", (e) => {
        document
          .querySelector(".response-container")
          .classList.add("tw-hidden");
        window.isPincodeFetched = false;
        document.querySelector(".pincode-failure").classList.add("hidden");
      });

    var pdpClickpostForm = document.querySelector(".clickpost-edd__form");
    const dropPincode = sessionStorage.getItem("drop_pincode");

    if (dropPincode) {
      pdpClickpostForm.querySelector('input[name="drop_pincode"]').value =
        dropPincode;
    }

    if (pdpClickpostForm) {
      var pincode = pdpClickpostForm.querySelector(
        'input[name="drop_pincode"]'
      ).value;

      if (this.currentVariant[0].available) {
        if (pincode) {
          window.globalFetchEdd(pincode);
        }
      } else {
        document
          .querySelector(".pincode-button")
          .setAttribute("disabled", true);
      }

      document
        .querySelector(".pincode-button")
        .addEventListener("click", (e) => {
          e.preventDefault();
          var pincode = pdpClickpostForm.querySelector(
            'input[name="drop_pincode"]'
          ).value;
          window.globalFetchEdd(pincode);
        });
    }
  }

  updatesForVolumeDiscount() {
    document.querySelectorAll(".volume-discount-wrapper")?.forEach((div) => {
      if (div.getAttribute("data-vd-variant-id") == this.currentVariant.id) {
        volumeDiscountWrapper = div;
      }
    });
    if (volumeDiscountWrapper) {
      volumeDiscountInventoryQuantities = volumeDiscountWrapper?.getAttribute(
        "data-inventory-quantity"
      );
      document
        .querySelectorAll(".volume-discount-variant-card")
        ?.forEach((card) => {
          card.addEventListener("click", () => {
            clickHandlerForVolumeDiscountVariants(card);
            // Reset the selected card to ensure clean state between selections
            selectedVolumeDiscountCard = null;
          });
        });
    }
  }

  getProductFromRadios(event) {
    this.productVariant = event.target.closest("product-variants");
    const selectedVariants = Array.from(
      this.productVariant.querySelectorAll('input[type="radio"]:checked')
    ).map((radio) => {
      let scriptTag = radio.nextElementSibling;
      if (scriptTag.tagName !== "SCRIPT") {
        let scriptTags = this.productVariant.querySelectorAll("script");
        scriptTags.forEach((script) => {
          let currentVariantId = radio.value;
          if (script.dataset.variantId == currentVariantId) {
            scriptTag = script;
          }
        });
      }
      let variantData;
      if (scriptTag && scriptTag.tagName === "SCRIPT") {
        try {
          variantData = JSON.parse(scriptTag.textContent);
        } catch (e) {
          console.warn("Invalid JSON in script tag", e);
        }
      }
      return variantData;
    });
    return selectedVariants;
  }

  getProductFromSelect() {
    const selects = Array.from(this.querySelectorAll("select"));
    const selectedVariants = selects.map((select) => {
      const selectedOption = select.options[select.selectedIndex];
      const scriptTag = selectedOption.nextElementSibling;
      let variantData;
      if (scriptTag) {
        variantData = JSON.parse(scriptTag.textContent);
      }
      return variantData;
    });
    return selectedVariants;
  }

  updateProductURL() {
    this.url = new URL(window.location);
    const currentPathParts = this.url.pathname.split("/");
    if (currentPathParts.length > 2) {
      currentPathParts[2] = this.productHandle; // Assuming the product handle is always at index 2
    }
    this.url.pathname = currentPathParts.join("/");
    let urlVariantId = this.currentVariant[0].id || this.currentVariant.id;
    this.url.searchParams.set("variant", urlVariantId);
    window.history.replaceState({}, "", this.url);
  }

  async fetchProductInfo() {
    if (this.closest("borosil-xs-card")) {
      this.url = `/products/${this.productHandle}?variant=${this.currentVariant.id}&sections=borosil-xs-product-variant-card`;

      try {
        const response = await fetch(this.url);
        const responseJson = await response.json();
        const rawHTML = responseJson["borosil-xs-product-variant-card"];
        const decodedHTML = rawHTML
          .replace(/&quot;/g, '"') // Replace &quot; with "
          .replace(/\\n/g, "") // Remove \n
          .replace(/\\&quot;/g, '"') // Handle escaped quotes within backslashes
          .replace(/&#39;/g, "'");
        this.html = new DOMParser().parseFromString(decodedHTML, "text/html");
        this.renderProductInfo(this.html);

        // Flits earn credit window object
        // window.flitsThemeAppExtensionObjects.product.product_handle =
        //   this.productHandle;
        // window.refreshFlitsCredits(this.currentVariant.id);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    } else if (this.productCard) {
      this.url = `/products/${this.productHandle}?variant=${this.currentVariant.id}&sections=borosil-product-card-render`;
      try {
        const response = await fetch(this.url);
        const responseJson = await response.json();
        const rawHTML = responseJson["borosil-product-card-render"];
        const decodedHTML = rawHTML
          .replace(/&quot;/g, '"') // Replace &quot; with "
          .replace(/\\n/g, "") // Remove \n
          .replace(/\\&quot;/g, '"')
          .replace(/&#39;/g, "'"); // Handle escaped quotes within backslashes
        this.html = new DOMParser().parseFromString(decodedHTML, "text/html");
        this.renderProductInfo(this.html);

        // Flits earn credit window object
        // window.flitsThemeAppExtensionObjects.product.product_handle =
        //   this.productHandle;
        // window.refreshFlitsCredits(this.currentVariant.id);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    } else if (this.cartProduct) {
      try {
        await this.addVariantToCart(this.currentVariant.id);

        // Optionally, remove the old variant if needed
        // await this.removeOldVariantFromCart(this.oldVariantId);
      } catch (error) {
        console.error("Error fetching cart info:", error);
      }
    } else {
      this.url = `/products/${this.productHandle}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`;
      try {
        const response = await fetch(this.url);
        const responseText = await response.text();
        this.html = new DOMParser().parseFromString(responseText, "text/html");
        this.renderProductInfo(this.html);

        // Flits earn credit window object
        window.flitsThemeAppExtensionObjects.product.product_handle =
          this.productHandle;
        window.refreshFlitsCredits(this.currentVariant.id);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    }
  }

  renderProductInfo(section) {
    const productCard = this.closest("borosil-product-card");

    const xsCard = this.closest("borosil-xs-card");
    const updatedContent = section.querySelector(
      `[data-product-variant-handle="${this.productHandle}"]`
    );

    if (
      this.productCard &&
      productCard &&
      productCard.dataset.view === "single" &&
      window.location.href.includes("/collections")
    ) {
      let horizontalsizevariants = productCard.querySelector(
        ".horizontal-size-variants"
      );
      // Handle 'single' view updates (partial, preserving listeners)
      const productImageWrapper = productCard.querySelector(
        ".product-card__image"
      );
      const newImg = updatedContent?.querySelector("img");
      if (productImageWrapper && newImg) {
        productImageWrapper.src = newImg.src;
        if (newImg.srcset) productImageWrapper.srcset = newImg.srcset;
        if (newImg.alt) productImageWrapper.alt = newImg.alt;
      }

      const replaceText = (selector) => {
        const oldEl = productCard.querySelector(selector);
        const newEl = updatedContent.querySelector(selector);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      };

      replaceText(".product__card__title");
      replaceText(".compare-at-price");
      replaceText(".selling-price");
      replaceText(".discount-percentage");

      // Update URL for the product card
      if (
        productCard.querySelector(".product-card__title") &&
        updatedContent.querySelector(".product-card__title")
      ) {
        productCard.querySelector(".product-card__title").href =
          updatedContent.querySelector(".product-card__title").href;
      }
      const productForm = productCard.querySelector("product-form");
      const updatedForm = updatedContent.querySelector("product-form");

      if (productForm && updatedForm) {
        // Get buttons and fallback sold out div
        const oldAddBtn = productForm.querySelector('button[name="add"]');
        const newAddBtn = updatedForm.querySelector('button[name="add"]');
        const soldOutText = productForm.querySelector(".sold-out-text");
        const checkedInput = updatedContent.querySelectorAll(
          "input.product__variant__swatches__input"
        );
        let isAvailable = false;
        if (checkedInput.length > 0) {
          checkedInput.forEach((input) => {
            if (input.checked) {
              isAvailable = input.dataset.available;
            }
          });
        } else {
          isAvailable = horizontalsizevariants.querySelector(
            "input[name=product-as-variants]:checked"
          ).dataset.available;
        }

        // CASE 1: Variant is available
        if (isAvailable) {
          // Remove old sold-out message if present
          if (soldOutText) soldOutText.remove();

          // If new ATC button exists in updatedForm, insert or replace
          if (newAddBtn) {
            if (oldAddBtn) {
              oldAddBtn.replaceWith(newAddBtn.cloneNode(true));
            } else {
              productForm
                .querySelector("form")
                .appendChild(newAddBtn.cloneNode(true));
            }
            productForm.submitButton =
              productForm.querySelector('[type="submit"]');
          } else {
            console.warn("Updated form is missing add-to-cart button");
          }

          // CASE 2: Variant is sold out
        } else {
          // Remove old add-to-cart button
          if (oldAddBtn) oldAddBtn.remove();

          // If sold-out message doesn't already exist, add it
          if (!soldOutText) {
            const div = document.createElement("div");
            div.className =
              "sold-out-text tw-text-[1.4rem] tw-font-medium tw-text-[#9A9A9A]";
            div.textContent = "Sold Out";
            productForm.appendChild(div);
          }
        }

        // Update inputs (product ID, variant ID)
        const updatedId = updatedForm.querySelector('input[name="id"]')?.value;
        const updatedProductId = updatedForm.querySelector(
          'input[name="product-id"]'
        )?.value;

        const inputId = productForm.querySelector('input[name="id"]');
        const inputProductId = productForm.querySelector(
          'input[name="product-id"]'
        );

        if (inputId && updatedId) inputId.value = updatedId;
        if (inputProductId && updatedProductId)
          inputProductId.value = updatedProductId;
      }

      const colorVariants = productCard.querySelectorAll(
        'input[name="product-as-variants-color"]'
      );

      const updatedColorVariants = updatedContent.querySelectorAll(
        ".product__color__variants"
      );
      const sizeVariants = productCard.querySelectorAll(
        'input[name="product-as-variants"]'
      );
      const updatedSizeVariants = updatedContent.querySelectorAll(
        ".product__size__variants"
      );
      const productVariantElementSize = this.classList.contains(
        "horizontal-size-variants"
      )
        ? this
        : null;
      const productVariantElement = this.classList.contains(
        "horizontal-color-variants"
      )
        ? this
        : null;

      let horizontalcolorvariants = productCard.querySelector(
        ".horizontal-color-variants"
      );

      let uniqueIndexNumber;
      if (productCard.querySelector("input[name=product-as-variants]")) {
        uniqueIndexNumber = productCard.querySelector(
          "input[name=product-as-variants]"
        ).dataset.uniqueIndex;
      }
      if (
        (colorVariants.length &&
          updatedColorVariants.length &&
          productVariantElement) ||
        (sizeVariants.length &&
          updatedSizeVariants.length &&
          productVariantElementSize)
      ) {
        const newColorElements = [];
        const newSizeElements = [];

        updatedColorVariants.forEach((updatedInput) => {
          const variantsBlock = updatedInput.querySelector("product-variants");
          if (!variantsBlock) return;

          const colorInputs = variantsBlock.querySelectorAll(
            'input[type="radio"]'
          );

          colorInputs.forEach((input) => {
            let scriptTag = input.nextElementSibling;
            if (!scriptTag || scriptTag.tagName !== "SCRIPT") {
              scriptTag = Array.from(
                this.productVariant.querySelectorAll("script")
              ).find((script) => script.dataset.variantId === input.value);
            }

            if (!scriptTag) return;

            let variantData;
            try {
              variantData = JSON.parse(scriptTag.textContent);
            } catch {
              console.warn("Error parsing color variant");
              return;
            }
            const isChecked =
              input.checked ||
              variantData.id == updatedContent.getAttribute("id");
            const inputDataset = {
              sectionId: input.dataset.sectionId,
              productCard: input.dataset.productCard,
            };

            const newInput = this.createVariantInput({
              type: "color",
              variantData,
              idPrefix: "color",
              updatedContent,
              uniqueIndexNumber,
              inputDataset,
              isChecked,
            });

            const newLabel = this.createVariantLabel({
              type: "color",
              variantData,
              newInput,
              uniqueIndexNumber,
              updatedContent,
              isChecked,
            });

            newColorElements.push({ input: newInput, label: newLabel });
          });
        });

        updatedSizeVariants.forEach((updatedInput) => {
          const variantBlocks =
            updatedInput.querySelectorAll("product-variants");
          if (!variantBlocks.length) return;

          variantBlocks.forEach((block) => {
            const sizeOptions = block.querySelectorAll("option");

            sizeOptions.forEach((input) => {
              const scriptTag = input.nextElementSibling;
              if (!scriptTag || scriptTag.tagName !== "SCRIPT") return;
              let variantData;
              try {
                variantData = JSON.parse(scriptTag.textContent);
              } catch {
                console.warn("Error parsing size variant");
                return;
              }
              const isChecked =
                input.checked ||
                variantData.id == updatedContent.getAttribute("id");

              const inputDataset = {
                sectionId: input.dataset.sectionId,
                productCard: input.dataset.productCard,
              };

              const newInput = this.createVariantInput({
                type: "size",
                variantData,
                idPrefix: "variant",
                updatedContent,
                uniqueIndexNumber,
                inputDataset,
                isChecked,
              });

              const newLabel = this.createVariantLabel({
                type: "size",
                variantData,
                newInput,
                uniqueIndexNumber,
                updatedContent,
                isChecked,
              });

              newSizeElements.push({ input: newInput, label: newLabel });
            });
          });
        });

        //  Apply diffing and DOM patching
        if (horizontalcolorvariants && newColorElements.length) {
          this.diffAndReplaceVariants({
            container: horizontalcolorvariants,
            newElements: newColorElements,
            name: "product-as-variants-color",
          });
        }

        if (horizontalsizevariants && newSizeElements.length) {
          this.diffAndReplaceVariants({
            container: horizontalsizevariants,
            newElements: newSizeElements,
            name: "product-as-variants",
          });
        }

        // Update color swatches based on selected size
        this.updateColorVariantsAfterSizeChange({
          productCard,
          updatedContent,
          uniqueIndexNumber,
        });
      }
    } else if (this.productCard && productCard) {
      this.currentProductHandle = productCard.dataset.productVariantHandle;
      productCard.innerHTML = updatedContent.innerHTML;
    } else if (xsCard) {
      this.currentProductHandle = xsCard.dataset.productVariantHandle;
      xsCard.innerHTML = updatedContent.innerHTML;
    } else {
      // Default fallback for main product area
      const mainProduct = document.querySelector(".main-product");
      if (mainProduct && section.querySelector(".main-product")) {
        mainProduct.innerHTML =
          section.querySelector(".main-product").innerHTML;
        mainProduct.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }

  //  Utility to create an input element for color or size
  createVariantInput({
    type, // 'color' or 'size'
    variantData,
    idPrefix,
    updatedContent,
    uniqueIndexNumber,
    inputDataset = {},
    isChecked = false,
  }) {
    const newInput = document.createElement("input");
    newInput.type = "radio";
    newInput.name =
      type === "color" ? "product-as-variants-color" : "product-as-variants";
    newInput.className =
      "product__variant__swatches__input tw-w-[0.1rem] tw-h-[0.1rem] tw-overflow-hidden tw-hidden";
    newInput.id = `${idPrefix}-${variantData.id}-${updatedContent.getAttribute(
      "id"
    )}-${uniqueIndexNumber}`;
    newInput.value = variantData.id;
    newInput.setAttribute("data-available", variantData.available);
    newInput.setAttribute("data-product-handle", variantData.handle);
    newInput.setAttribute("data-variant-id", variantData.id);

    if (type === "color") {
      newInput.setAttribute("data-unique-id", uniqueIndexNumber);
    } else {
      newInput.setAttribute("data-unique-index", uniqueIndexNumber);
    }

    if (inputDataset.sectionId) {
      newInput.setAttribute("data-section-id", inputDataset.sectionId);
    }
    if (inputDataset.productCard) {
      newInput.setAttribute("data-product-card", "true");
    }
    if (isChecked) newInput.checked = true;
    return newInput;
  }

  //  Utility to create a label for variant input
  createVariantLabel({
    type,
    variantData,
    newInput,
    uniqueIndexNumber,
    updatedContent,
    isChecked,
  }) {
    const label = document.createElement("label");
    label.setAttribute("for", newInput.id);
    label.setAttribute("data-variant-id", variantData.id);
    label.className =
      type == "color"
        ? `product-as-variants-color-label tw-max-w-[8.2rem] color-${uniqueIndexNumber} !tw-p-0 !tw-rounded-none`
        : `product__size__variant size-${uniqueIndexNumber} tw-cursor-pointer product-as-variants-label`;

    if (isChecked) {
      label.classList.add("checked");
    }
    if (!variantData.available) {
      label.classList.add("disabled-variant", "tw-opacity-50", "disabled");
      if (type === "color") label.classList.add("product__color__variant");
      if (type === "size") label.classList.add("tw-line-through");
    }

    if (type === "color") {
      const div = document.createElement("div");
      div.className = "tw-w-full tw-h-full";
      const img = document.createElement("img");
      img.src = variantData.featured_image || "";
      img.alt = variantData.title || "Color Variant";
      img.loading = "lazy";
      div.appendChild(img);
      label.appendChild(div);
    } else {
      label.textContent = variantData.available
        ? variantData.variants[0].option1
        : `${variantData.variants[0].option1} - Sold out`;
    }

    return label;
  }

  //  Utility to diff and update DOM
  diffAndReplaceVariants({ container, newElements, name }) {
    const newIds = newElements.map(({ input }) => input.id);

    const existingInputs = Array.from(
      container.querySelectorAll(`input[name="${name}"]`)
    );

    // Add or update elements
    newElements.forEach(({ input, label }) => {
      const existingInput = container.querySelector(`#${input.id}`);
      const existingLabel = container.querySelector(`label[for="${input.id}"]`);

      if (!existingInput) {
        container.appendChild(input);
        container.appendChild(label);
      } else {
        existingInput.checked = input.checked;

        const existingImg = existingLabel?.querySelector("img");
        const newImg = label.querySelector("img");
        if (existingImg && newImg) {
          existingImg.src = newImg.src;
          existingImg.alt = newImg.alt;
        }

        if (
          existingLabel &&
          !existingLabel.innerHTML.includes(existingImg?.outerHTML || "") &&
          existingLabel.textContent !== label.textContent
        ) {
          existingLabel.textContent = label.textContent;
        }
      }
    });

    // Remove stale inputs
    existingInputs.forEach((input) => {
      if (!newIds.includes(input.id)) {
        const label = container.querySelector(`label[for="${input.id}"]`);
        input.remove();
        if (label) label.remove();
      }
    });
  }

  // Utility to generate all color variant elements from script tags
  generateColorElementsFromScripts({
    productCard,
    updatedContent,
    uniqueIndexNumber,
    sizeInputs,
    selectedColorId,
  }) {
    const scriptTags =
      updatedContent
        .querySelector(".product__color__variants")
        ?.querySelectorAll("script") || [];

    return Array.from(scriptTags).map((script) => {
      const variantData = JSON.parse(script.textContent);
      const isChecked = variantData.id == selectedColorId;
      const inputDataset = {
        sectionId: sizeInputs[0]?.dataset.sectionId,
        productCard: sizeInputs[0]?.dataset.productCard,
      };

      const newInput = this.createVariantInput({
        type: "color",
        variantData,
        idPrefix: "color",
        updatedContent,
        uniqueIndexNumber,
        inputDataset,
        isChecked,
      });

      const newLabel = this.createVariantLabel({
        type: "color",
        variantData,
        newInput,
        uniqueIndexNumber,
        updatedContent,
        isChecked,
      });

      return { input: newInput, label: newLabel };
    });
  }

  updateColorVariantsAfterSizeChange({
    productCard,
    updatedContent,
    uniqueIndexNumber,
  }) {
    const sizeInputs = productCard.querySelectorAll(
      'input[name="product-as-variants"]'
    );

    const selectedColorInput = productCard.querySelector(
      'input[name="product-as-variants-color"]:checked'
    );

    const selectedColorId = selectedColorInput?.value;
    const newColorElements = this.generateColorElementsFromScripts({
      productCard,
      updatedContent,
      uniqueIndexNumber,
      sizeInputs,
      selectedColorId,
    });

    const colorContainer = productCard.querySelector(
      ".horizontal-color-variants"
    );

    if (colorContainer) {
      this.diffAndReplaceVariants({
        container: colorContainer,
        newElements: newColorElements,
        name: "product-as-variants-color",
      });
    }
  }

  setUnavailable() {
    const productForm = document.getElementById(
      `product-form--${this.sectionId}--${this.productId}`
    );
    const addButtonText = productForm.querySelector(
      '[name="add"] > .button--atc__text'
    );
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );

    if (addButtonText) addButtonText.textContent = "Unavailable";
    [price, inventory, sku, pricePerItem].forEach((el) =>
      el?.classList.add("visibility-hidden")
    );
  }

  async addVariantToCart(variantId) {
    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1, // Adjust quantity as needed
        },
      ],
    });

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      });

      if (!response.ok) throw new Error("Failed to add variant to cart");
      const data = await response.json();
      this.cart.renderContents(response);
    } catch (error) {
      console.error("Error adding variant to cart:", error);
    }
  }

  async removeOldVariantFromCart(oldVariantId) {
    const body = JSON.stringify({
      updates: {
        [oldVariantId]: 0, // Set quantity to 0 to remove the old variant
      },
    });

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      });

      if (!response.ok)
        throw new Error("Failed to remove old variant from cart");
      const data = await response.json();
    } catch (error) {
      console.error("Error removing old variant from cart:", error);
    }
  }
}

customElements.define("product-variants", ProductVariants);
